import React, { Suspense } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { TDR } from 'tdr-common';
import { AvailabilityGuardContext, serializeSearchFiltersForURL } from '../../routes/AvailabilityGuard';
import { InventoryCarousel } from '../inventory-carousel/InventoryCarousel';
import { InventoryCarouselSkeleton } from '../inventory-carousel/InventoryCarouselSkeleton';

const TableCarousel = () => {
	const { searchFilters } = useOutletContext<AvailabilityGuardContext>();
	const navigate = useNavigate();

	// A card from a service-scoped section carries the package's own start time, so the table page
	// opens on the product the guest actually clicked rather than on whatever time they searched.
	const onTableClick = (table: TDR.Table, slotTime?: string) => {
		const filters = slotTime ? { ...searchFilters, time: slotTime } : searchFilters;
		navigate({ pathname: `${table.slug}`, search: serializeSearchFiltersForURL(filters).toString() });
	};

	return (
		<Suspense fallback={<InventoryCarouselSkeleton />}>
			<InventoryCarousel onClick={onTableClick} />
		</Suspense>
	);
};

export default TableCarousel;
